module.exports = __webpack_public_path__ + "img/alu-guide-bottom.68f972e2.svg";